import axios from "axios";
import {toast} from "react-toastify";
import {
    setEditPrescription, setEditPrescriptionReload,
    setEditReferral,
    setEditReferralReload
} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import {openTabByType} from "../../../../_helpers/tabOpeners";

export const sendDigitally = (type, barcode, setLoading, company) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/send-digitally`, {
        company: company.id,
        barcode: barcode,
        type: type,
    }).then((res) => {
        if (res.data.status === "200") {
            toast.success(`Επιτυχής αποστολή ${type === "prescriptions" ? "συνταγής" : type === "referrals" ? "παραπεμπτικού" : ""} σε ηλεκτρονική μορφή.`);
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
}

export const printPrescription = (barcode, setLoading, company, extraHooks = {}) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/print-prescription`, {
        company: company.id,
        barcode: barcode,
        ...extraHooks
    }).then((res) => {
        if (res.data.status === "200") {
            const binaryString = atob(res.data.data);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);

            const printWindow = window.open(blobUrl, '_blank');
            if (printWindow) {
                printWindow.addEventListener('load', () => {
                    printWindow.focus();
                    printWindow.print();
                });
            } else {
                toast.error("Η εκτύπωση μπλοκαρίστηκε από τον περιηγητή.");
            }
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση.");
    })
}

export const downloadPrescription = (barcode, setLoading, company, extraHooks = {}) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/print-prescription`, {
        company: company.id,
        barcode: barcode,
        ...extraHooks
    }).then((res) => {
        if (res.data.status === "200") {
            const binaryString = atob(res.data.data);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `Συνταγή ${barcode}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση.");
    })
}

export const printReferral = (barcode, setLoading, company, extraHooks = {}) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/print-referral`, {
        company: company.id,
        barcode: barcode,
        ...extraHooks,
    }).then((res) => {
        if (res.data.status === "200") {
            const binaryString = atob(res.data.data);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);

            const printWindow = window.open(blobUrl, '_blank');
            if (printWindow) {
                printWindow.addEventListener('load', () => {
                    printWindow.focus();
                    printWindow.print();
                });
            } else {
                toast.error("Η εκτύπωση μπλοκαρίστηκε από τον περιηγητή.");
            }
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση.");
    })
}

export const downloadReferral = (barcode, setLoading, company, extraHooks = {}) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/print-referral`, {
        company: company.id,
        barcode: barcode,
        ...extraHooks
    }).then((res) => {
        if (res.data.status === "200") {
            const binaryString = atob(res.data.data);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `Παραπεμπτικό ${barcode}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την άντληση.");
    })
}

export const downloadVisitReferrals = (visitId, setLoading, company) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/print-visit-referrals`, {
        company: company.id,
        visitId: visitId,
    }).then((res) => {
        if (res.data.status === "200") {
            const binaryString = atob(res.data.data);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `Παραπεμπτικά επίσκεψης ${visitId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
}

export const printVisitReferrals = (visitId, setLoading, company) => {
    if (typeof setLoading === "function") setLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/prescription/print-visit-referrals`, {
        company: company.id,
        visitId: visitId,
    }).then((res) => {
        if (res.data.status === "200") {
            const binaryString = atob(res.data.data);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            const printWindow = window.open(blobUrl, '_blank');
            if (printWindow) {
                printWindow.addEventListener('load', () => {
                    printWindow.focus();
                    printWindow.print();
                });
            } else {
                toast.error("Η εκτύπωση μπλοκαρίστηκε από τον περιηγητή.");
            }
        } else {
            toast.error(res.data.message);
        }
        if (typeof setLoading === "function") setLoading(false);
    }).catch((err) => {
        if (typeof setLoading === "function") setLoading(false);
        console.log(err);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
}

export const openPrescription = (barcode, TABS_DATA, extraHooks = {}) => {
    return (dispatch) => {
        dispatch(setEditPrescription({...extraHooks, barcode: barcode}));
        dispatch(setEditPrescriptionReload(true));
        dispatch(openTabByType("prescription-edit", TABS_DATA));
    }
}

export const openReferral = (barcode, TABS_DATA, extraHooks = {}) => {
    return (dispatch) => {
        dispatch(setEditReferral({...extraHooks, barcode: barcode}));
        dispatch(setEditReferralReload(true));
        dispatch(openTabByType("referral-edit", TABS_DATA));
    }
}
